<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-card-title>
                        <h5>Batteries :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.searchBatteriesList"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.BatteriesHeaders"
                        :items="$store.state.batteriesListBool"
                        :items-per-page="15"
                        :single-select="true"
                        :search="$store.state.searchBatteriesList"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                                <v-spacer></v-spacer>
                                <v-dialog
                                    v-model="dialogEdit"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="primary"
                                            dark
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            +
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>
                                        <FormulaireBatteries></FormulaireBatteries>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeEdit"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.batteriesEditedItem.DESC_NL != '' && 
                                                    $store.state.batteriesEditedItem.DESC_FR != '' &&
                                                    $store.state.batteriesEditedItem.TYPE != '' &&
                                                    $store.state.batteriesEditedItem.COMPATIBILITY != '' &&
                                                    $store.state.batteriesEditedItem.ACCESSORIES != '' " 
                                                color="blue darken-1"
                                                text
                                                @click="saveEdit"
                                            >
                                                Enregistrer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog
                                    v-model="dialogCopy"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">Copier la batterie</span>
                                        </v-card-title>
                                        <FormulaireBatteries></FormulaireBatteries>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeCopy"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.batteriesEditedItem.DESC_NL != '' && 
                                                    $store.state.batteriesEditedItem.DESC_FR != '' &&
                                                    $store.state.batteriesEditedItem.TYPE != '' &&
                                                    $store.state.batteriesEditedItem.COMPATIBILITY != '' &&
                                                    $store.state.batteriesEditedItem.ACCESSORIES != '' " 
                                                color="blue darken-1"
                                                text
                                                @click="saveCopy"
                                            >
                                                Ajouter
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Voulez-vous supprimer cette batterie ?</v-card-title>
                                        <v-card-text>
                                            {{ $store.state.batteriesEditedItem.Reference }} {{ $store.state.batteriesEditedItem.BatterieAlias }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="copyItem(item)"
                            >
                                mdi-content-copy
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.FullBlack="{ item }">
                            <v-simple-checkbox
                                v-model="item.FullBlack"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.Bisun="{ item }">
                            <v-simple-checkbox
                                v-model="item.Bisun"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.optimizer="{ item }">
                            <v-simple-checkbox
                                v-model="item.optimizer"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import axios from 'axios';
    import createListBoolMixins from './mixins/createListBoolMixins.js';
	import FormulaireBatteries from './FormulaireBatteries.vue';

	export default {
    name: "GestionBatteries",
    components: { FormulaireBatteries },
    mixins: [
        createListBoolMixins,
    ],
    data: function () {
        return {
            dialogEdit: false,
            dialogCopy: false,
            dialogDelete: false,
            editedIndex: -1,
            formHasErrors: false,
            defaultItem: {
                Reference: '',
                Manufacturer: '',
                Manufacturer_ID: '',
                BatterieId: '',
                Name: '',
                PModMPP: 0,
                CellType: '',
                FullBlack: false,
                Bisun: false,
                optimizer: false,
                STOREDGE: false,
                MaleConnector: '',
                FemaleConnector: '',
                YmaleConnector: '',
                YfemaleConnector: '',
                mc4FuseType: '',
                BatterieAlias: '',
            },
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nouvelle batterie" : "Modifier la batterie";
        },
    },
    watch: {
        dialogEdit(val) {
            val || this.closeEdit();
        },
        dialogCopy(val) {
            val || this.closeCopy();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    mounted() {
        this.createBatteriesListBool();
    },
    methods: {
        getColor(admin) {
            if (admin == 0)
                return "red";
            else
                return "green";
        },
        editItem(item) {
            this.editedIndex = this.$store.state.batteriesListBool.indexOf(item);
            this.$store.state.batteriesEditedItem = Object.assign({}, item);
            this.dialogEdit = true;
        },
        copyItem(item) {
            this.editedIndex = this.$store.state.batteriesListBool.indexOf(item);
            this.$store.state.batteriesEditedItem = Object.assign({}, item);
            this.dialogCopy = true;
        },
        deleteItem(item) {
            this.editedIndex = this.$store.state.batteriesListBool.indexOf(item);
            this.$store.state.batteriesEditedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.$store.state.batteriesListBool.splice(this.editedIndex, 1);
            this.closeDelete();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/deleteBattery.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.batteriesEditedItem.ID;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.batteriesResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.batteriesListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadBatteriesList.php";
                    axios.get(link).then(response => {
                        this.$store.state.batteriesList = response.data;
                        this.createBatteriesListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        closeEdit() {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.$store.state.batteriesEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeCopy() {
            this.dialogCopy = false;
            this.$nextTick(() => {
                this.$store.state.batteriesEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.$store.state.batteriesEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        saveEdit() {
            if (this.editedIndex > -1) {
                Object.assign(this.$store.state.batteriesListBool[this.editedIndex], this.$store.state.batteriesEditedItem);
                var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/editBattery.php";
            }
            else {
                this.$store.state.batteriesListBool.push(this.$store.state.batteriesEditedItem);
                link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addBattery.php";
            }
            this.closeEdit();
            this.$store.state.axios_error = "";
            var data = this.$store.state.batteriesEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.batteriesResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.batteriesListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadBatteriesList.php";
                    axios.get(link).then(response => {
                        this.$store.state.batteriesList = response.data;
                        this.createBatteriesListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        saveCopy() {
            this.closeCopy();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addBattery.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.batteriesEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.batteriesResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.batteriesListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadBatteriesList.php";
                    axios.get(link).then(response => {
                        this.$store.state.batteriesList = response.data;
                        this.createBatteriesListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
    },
}
</script>
